import { makeClosedTask, makeOptions, normalizeMay2026Variant, pick } from "../../../../matura/MaturaMay2026ClosedTaskSupport";

const OPTION_LABELS = ["A", "B", "C", "D"];

function makeAscendingIntegerOptions(correctValue, candidateValues) {
  const values = Array.from(new Set(candidateValues.map(Number))).sort((left, right) => left - right);
  const options = values.map((value, index) => ({
    label: OPTION_LABELS[index],
    latex: String(value),
    isCorrect: value === correctValue,
  }));
  return { options, correctIndex: options.findIndex((option) => option.isCorrect) };
}

export function task01(variant) {
  if (variant === "original") {
    const fixed = [["A", "1"], ["B", "2"], ["C", "3"], ["D", "4"]];
    const { options, correctIndex } = makeOptions("3", [], fixed);
    return makeClosedTask({
      type: "MaturaSqrtProductPlusPowerClosedTask",
      taskNumber: "1",
      variant,
      tags: ["liczby", "pierwiastki", "potegi"],
      data: {
        instruction: "Dokończ zdanie. Wybierz właściwą odpowiedź spośród podanych.",
        prompt: "Liczba jest równa:",
        latex: "\\sqrt{\\tfrac{25}{8}}\\cdot\\sqrt{2}+2^{-1}",
        options,
        correctIndex,
        explanationTitles: ["Łączymy pierwiastki w jeden pierwiastek.", "Zapisujemy potęgę o wykładniku ujemnym jako odwrotność.", "Wykonujemy końcowe dodawanie lub odejmowanie."],
      explanationLines: [
          "\\sqrt{\\tfrac{25}{8}}\\cdot\\sqrt{2}=\\sqrt{\\tfrac{25}{4}}=\\tfrac{5}{2}",
          "2^{-1}=\\tfrac{1}{2}",
          "\\tfrac{5}{2}+\\tfrac{1}{2}=3",
        ],
      },
    });
  }

  const pool = [
    { n: 3, s: 2, rad: 2, base: 2, sign: "+", result: "2" },
    { n: 5, s: 2, rad: 2, base: 2, sign: "+", result: "3" },
    { n: 7, s: 2, rad: 3, base: 2, sign: "+", result: "4" },
    { n: 9, s: 2, rad: 5, base: 2, sign: "+", result: "5" },
    { n: 5, s: 3, rad: 2, base: 3, sign: "+", result: "2" },
    { n: 8, s: 3, rad: 3, base: 3, sign: "+", result: "3" },
    { n: 4, s: 5, rad: 5, base: 5, sign: "+", result: "1" },
    { n: 9, s: 2, rad: 2, base: 2, sign: "-", result: "4" },
    { n: 7, s: 2, rad: 3, base: 2, sign: "-", result: "3" },
    { n: 10, s: 3, rad: 5, base: 3, sign: "-", result: "3" },
    { n: 11, s: 2, rad: 5, base: 2, sign: "-", result: "5" },
    { n: 6, s: 5, rad: 3, base: 5, sign: "-", result: "1" },
  ];
  const item = pick(pool);
  const denominator = item.s * item.s * item.rad;
  const reciprocal = "\\tfrac{1}{" + item.base + "}";
  const value = Number(item.result);
  const { options, correctIndex } = makeAscendingIntegerOptions(value, [value - 1, value, value + 1, value + 2]);
  return makeClosedTask({
    type: "MaturaSqrtProductPlusPowerClosedTask",
    taskNumber: "1",
    variant,
    tags: ["liczby", "pierwiastki", "potegi"],
    data: {
      instruction: "Dokończ zdanie. Wybierz właściwą odpowiedź spośród podanych.",
      prompt: "Liczba jest równa:",
      latex: "\\sqrt{\\tfrac{" + (item.n * item.n) + "}{" + denominator + "}}\\cdot\\sqrt{" + item.rad + "}" + item.sign + item.base + "^{-1}",
      options,
      correctIndex,
      explanationTitles: ["Łączymy pierwiastki w jeden pierwiastek.", "Zapisujemy potęgę o wykładniku ujemnym jako odwrotność.", "Wykonujemy końcowe dodawanie lub odejmowanie."],
        explanationLines: [
        "\\sqrt{\\tfrac{" + (item.n * item.n) + "}{" + denominator + "}}\\cdot\\sqrt{" + item.rad + "}=\\sqrt{\\tfrac{" + (item.n * item.n) + "}{" + (item.s * item.s) + "}}=\\tfrac{" + item.n + "}{" + item.s + "}",
        item.base + "^{-1}=" + reciprocal,
        "\\tfrac{" + item.n + "}{" + item.s + "}" + item.sign + reciprocal + "=" + item.result,
      ],
    },
  });
}

export function generateTask(options = {}) {
  return task01(normalizeMay2026Variant(options));
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
